import { render } from "./editModal.vue?vue&type=template&id=3b2f8400"
import script from "./editModal.vue?vue&type=script&lang=js"
export * from "./editModal.vue?vue&type=script&lang=js"

import "./editModal.vue?vue&type=style&index=0&id=3b2f8400&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__